module.exports = __webpack_public_path__ + "img/rc-logo-full.png";